import { Link } from 'react-router-dom';
import { Shield, Facebook, Twitter, Instagram } from 'lucide-react';

export default function Footer() {
  return (
    <footer className="bg-navy text-white" data-testid="main-footer">
      <div className="section-divider" />
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-2 mb-4">
              <Shield className="w-8 h-8 text-gold" />
              <span className="font-heading font-bold text-xl">SAFE FLORIDA</span>
            </div>
            <p className="font-signature text-gold text-2xl mb-3">F.C. Clark</p>
            <p className="text-sm text-white/70 font-body leading-relaxed">
              Protecting Families. Securing Land. Strengthening Communities. A Community Membership Movement.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-heading font-bold text-gold text-sm tracking-wider uppercase mb-4">Quick Links</h4>
            <nav className="space-y-2">
              {[{ l: 'Home', p: '/' }, { l: 'About', p: '/about' }, { l: 'Programs', p: '/programs' }, { l: 'Store', p: '/store' }, { l: 'News', p: '/news' }, { l: 'FAQ', p: '/faq' }, { l: 'Contact', p: '/contact' }].map(({ l, p }) => (
                <Link key={p} to={p} className="block text-sm text-white/70 hover:text-gold transition-colors font-body" data-testid={`footer-link-${l.toLowerCase()}`}>{l}</Link>
              ))}
            </nav>
          </div>

          {/* Programs */}
          <div>
            <h4 className="font-heading font-bold text-gold text-sm tracking-wider uppercase mb-4">Programs</h4>
            <nav className="space-y-2">
              {[{ l: 'Membership', p: '/programs/membership' }, { l: 'Seat at the Table', p: '/programs/seat-at-the-table' }, { l: 'Legal Defense Fund', p: '/programs/legal-defense-fund' }, { l: 'Priority Zones', p: '/programs/priority-zones' }].map(({ l, p }) => (
                <Link key={p} to={p} className="block text-sm text-white/70 hover:text-gold transition-colors font-body">{l}</Link>
              ))}
            </nav>
          </div>

          {/* Legal & Social */}
          <div>
            <h4 className="font-heading font-bold text-gold text-sm tracking-wider uppercase mb-4">Legal</h4>
            <nav className="space-y-2 mb-6">
              <Link to="/legal/privacy" className="block text-sm text-white/70 hover:text-gold transition-colors font-body">Privacy Policy</Link>
              <Link to="/legal/terms" className="block text-sm text-white/70 hover:text-gold transition-colors font-body">Terms of Service</Link>
              <Link to="/legal/membership-agreement" className="block text-sm text-white/70 hover:text-gold transition-colors font-body">Membership Agreement</Link>
            </nav>
            <div className="flex gap-4">
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="text-white/70 hover:text-gold transition-colors" data-testid="social-facebook"><Facebook className="w-5 h-5" /></a>
              <a href="https://x.com" target="_blank" rel="noopener noreferrer" className="text-white/70 hover:text-gold transition-colors" data-testid="social-x"><Twitter className="w-5 h-5" /></a>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="text-white/70 hover:text-gold transition-colors" data-testid="social-instagram"><Instagram className="w-5 h-5" /></a>
            </div>
          </div>
        </div>

        {/* Hashtags */}
        <div className="mt-12 pt-8 border-t border-white/10 text-center">
          <p className="text-sm text-gold/80 font-body mb-2">
            #SafeFlorida #SupportLocalBusiness #EconomicAccountability #TransparencyMatters
          </p>
          <p className="text-xs text-white/50 font-body">
            &copy; {new Date().getFullYear()} Safe Florida. All rights reserved. 501(c)(4) Social Welfare Organization. Port St. Lucie, FL.
          </p>
        </div>
      </div>
    </footer>
  );
}
